<template>
    <div class="fill-height">
        <v-container fluid>
            <v-row justify="center">
                <v-flex xs6 sm4 md3 lg1 mt-2>
                    <router-link to="/youtv/">
                        <v-img src="/img/youtv_logo.png"></v-img>
                    </router-link>
                </v-flex>
            </v-row>
            <v-layout align-center justify-center>
                <v-flex xs12 sm12 md6 lg4>
                    <material-card class="text-center title font-weight-bold" color="youtv" title="Дякуємо!">
                        <v-card-text>
                            <p class="body-1">Код активації You TV надіслано SMS-повідомленням на: 
                            <span class="font-weight-bold red--text">{{phone}}</span>
                            </p>
                            <p class="body-1">Дякуємо, що обрали You TV.<br> Приємного перегляду!</p>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn dark color="blue" text @click="$router.go(-1)">
                                <v-icon right dark>mdi-keyboard-return</v-icon> Повернутись
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
    
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn dark color="blue" :loading="resendLoading" text @click="resendCode()">Надіслати ще раз <v-icon right dark>mdi-reload</v-icon>
                            </v-btn>
                            <v-btn dark color="blue" text @click="printCode()" v-if="!$vuetify.breakpoint.xsOnly">Надрукувати <v-icon right dark>mdi-printer</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                        <v-card-actions v-if="$vuetify.breakpoint.xsOnly">
                            <v-spacer></v-spacer>
                            <v-btn dark color="blue" text @click="printCode()">Надрукувати <v-icon right dark>mdi-printer</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
    
                    </material-card>
                </v-flex>
            </v-layout>
        </v-container>
        <!--   Для печати -->
        <div id="print-content">
            <div class="text-center p-5" style="background-color: #3eb8b3;">
                <h1 style="color:#fff">Код активації передплати<br>
                {{printName}}
                </h1>
                <div class="row mx-auto p-4">
                    <div class="col-md-4 border border-white my-auto p-4 text-center">
                        <h1>{{serviceCODE}}</h1>
                    </div>
                    <div class="col-md-8 text-left my-auto font-weight-bold">
                        <ul style="list-style-type: decimal">
                            <li> Зайдіть на сторінку megogo.net/code (або у профіль додатку megog на мобільному, планшеті або Smart-TV)</li>
                            <li> Авторизуйтесь або зареєструйтесь</li>
                            <li> Введіть код активації у відповідне поле</li>
                        </ul>
                    </div>
                </div>
    
                <p class="text-left">Ця послуга надає Користувачеві можливість доступу до визначеного Адміністрацією переліку Контенту на сайті megogo.net/rules.
                    Активація передплати підтверджує згоду Користувача з даною угодою.
                    За інформацією звертайтеся: support@megogo.net або за телефоном 0 800-751-234 (дзвінки на територій України згідно з тарифами вашого оператора).
                </p>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    import {
        mapActions
    } from 'vuex'
    
    export default {
        props: {
            phone: String,
            serviceCODE: String,
            printName: String
        },
        data() {
            return {
                loading: false,
                resendLoading: false
            }
        },
        methods: {
            ...mapActions(['resendYoutvCODE', 'setSnackbar']),
            resendCode() {
                this.resendLoading = true
                this.resendYoutvCODE({
                        code: this.serviceCODE
                    })
                    .then(() => this.resendLoading = false)
            },
            printCode() {
                this.$htmlToPaper('print-content');
            }
        },
        created() {},
        computed: {}
    }
    </script>
    
    <style>
    #print-content {
        display: none;
        background-color: #3eb8b3;
    }
    </style>
    